import { configureStore } from "@reduxjs/toolkit";
import { rootReducer as reducer } from "atp-rule-binder";

export const store = configureStore({
  reducer,
});
